import {BufferWriter, Writer} from "protobufjs";

import {MessageRoom} from "../../../domain/model/message_room";
import {IScoutRepository} from "../../../domain/repository/scout_repository";

import {IApiClient} from "../client";
import {api, entity} from "../rpc/api";
import {getToken} from "./bind_token";

import {NotificationClient} from "../../../config/view_const/notification";
import {AppError, ErrorType} from "../../../domain/model/app_error";
import {MessageRoomConvertResponse} from "./message_room_api_convert";
import CreateScoutRequest = api.CreateScoutRequest;

class ScoutAPI implements IScoutRepository {
    constructor(readonly apiClient: IApiClient) {
    }

    public create(
        customerID: string,
        projectID: string,
        message: string
    ): Promise<MessageRoom> {
        return new Promise<MessageRoom>((resolve, reject) => {
            getToken()
                .then((token: string): Promise<Uint8Array> => {
                    const req: CreateScoutRequest = new CreateScoutRequest();
                    req.customerID = customerID;
                    req.projectID = projectID;
                    req.message = message;

                    const writer: BufferWriter | Writer = Writer.create();
                    return this.apiClient.postWithToken(
                        "/api.ScoutService/Create",
                        token,
                        CreateScoutRequest.encode(req, writer).finish()
                    );
                })
                .then((binary: Uint8Array): void => {
                    const res: entity.MessageRoom = entity.MessageRoom.decode(binary);
                    // BE=>FE 型変換
                    const resConverted: MessageRoomConvertResponse =
                        MessageRoomConvertResponse.from(res);
                    const item: MessageRoom = MessageRoom.from(resConverted);
                    resolve(item);
                })
                .catch((error: Error): void => {
                    if (error instanceof AppError) {
                        if (error.type === ErrorType.API_REQUEST_403) {
                            reject(
                                new AppError(
                                    error.code,
                                    ErrorType.FAIL_CUSTOMER_SCOUT,
                                    NotificationClient.failureCreateScout
                                )
                            );
                        } else {
                            reject(error);
                        }
                    }
                });
        });
    }
}

const createScoutAPI = (apiClient: IApiClient): IScoutRepository => {
    return new ScoutAPI(apiClient);
};

export {createScoutAPI};



// WEBPACK FOOTER //
// ./src/infra/api/service/scout_api.ts